var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1531 35.0454H28.1001",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4338 38.2051H28.1001",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7143 41.3647H28.1001",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4873_30519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.8147e-06H48.5V48H0.5V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4873_30519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9611 31.0349H14.3369V44.0686H16.9611C17.3071 44.0686 17.5877 43.788 17.5877 43.442V31.6615C17.5877 31.3155 17.3071 31.0349 16.9611 31.0349Z",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8724 31.8857H27.577C27.4106 31.8857 27.2938 31.7472 27.2971 31.5993V26.49C27.2971 25.8734 26.7986 25.371 26.182 25.3689H26.1761C25.5562 25.3689 24.9927 25.7275 24.7304 26.2893C24.1378 27.5586 24.3174 28.9573 22.4581 30.8076C21.541 31.7202 20.2914 32.2199 18.9975 32.2199H17.5879V43.2028H18.3791C19.2957 43.2028 20.1979 43.4299 21.0053 43.8637C21.8126 44.2974 22.7149 44.5244 23.6314 44.5244H31.7141C32.5868 44.5244 33.294 43.8172 33.294 42.9446C33.294 42.0722 32.5868 41.3648 31.7141 41.3648H32.4336C33.3061 41.3648 34.0135 40.6574 34.0135 39.7849C34.0135 38.9124 33.3061 38.2051 32.4336 38.2051H33.153C34.0255 38.2051 34.7328 37.4978 34.7328 36.6252C34.7328 35.7527 34.0255 35.0454 33.153 35.0454H33.8724C34.7449 35.0454 35.4522 34.3381 35.4522 33.4656C35.4522 32.593 34.7449 31.8857 33.8724 31.8857Z",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3361 12.9464C41.3361 19.7081 35.8546 25.1897 29.0928 25.1897C22.3311 25.1897 16.8496 19.7081 16.8496 12.9464C16.8496 6.1847 22.3311 0.703136 29.0928 0.703136C35.8546 0.703136 41.3361 6.1847 41.3361 12.9464Z",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2974 44.5244V45.5011C27.2974 46.4929 28.1014 47.2969 29.0931 47.2969C30.0849 47.2969 30.8889 46.4929 30.8889 45.5011V44.5244H27.2974Z",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0927 25.1897C28.4826 25.1897 27.8832 25.1445 27.2969 25.0583V26.4901V31.5993C27.2937 31.7473 27.4105 31.8857 27.5769 31.8857H30.8885V25.0583C30.3023 25.1445 29.7028 25.1897 29.0927 25.1897Z",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6409 45.2678H13.4414C13.936 45.2678 14.3371 44.8668 14.3371 44.372V30.7317C14.3371 30.237 13.936 29.8359 13.4414 29.8359H8.55936C8.06464 29.8359 7.66357 30.237 7.66357 30.7317V44.372C7.66357 44.8668 8.06464 45.2678 8.55936 45.2678H12.8753",
    stroke: "#020202",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 8L24 18M24 8L34 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDark);
export default __webpack_public_path__ + "static/media/no-dark.e134dd546c28c4f3f69af51ddc4697d7.svg";
export { ForwardRef as ReactComponent };